import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'star-minus',
  size: 24,
  node: [
    ['path', { d: 'M15 18h6', key: '3b3c90' }],
    [
      'path',
      {
        d: 'M17.688 14a2.1 2.1 0 0 1 .416-.568l3.736-3.638a.53.53 0 0 0-.294-.905l-5.166-.755a2.1 2.1 0 0 1-1.595-1.16l-2.31-4.68a.53.53 0 0 0-.95.001L9.216 6.974a2.1 2.1 0 0 1-1.597 1.16l-5.165.755a.53.53 0 0 0-.294.906l3.736 3.637a2.1 2.1 0 0 1 .611 1.879l-.88 5.139a.53.53 0 0 0 .769.56l4.617-2.428.027-.014',
        key: 'rwo527',
      },
    ],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name StarMinus
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTUgMThoNiIgLz4KICA8cGF0aCBkPSJNMTcuNjg4IDE0YTIuMSAyLjEgMCAwIDEgLjQxNi0uNTY4bDMuNzM2LTMuNjM4YS41My41MyAwIDAgMC0uMjk0LS45MDVsLTUuMTY2LS43NTVhMi4xIDIuMSAwIDAgMS0xLjU5NS0xLjE2bC0yLjMxLTQuNjhhLjUzLjUzIDAgMCAwLS45NS4wMDFMOS4yMTYgNi45NzRhMi4xIDIuMSAwIDAgMS0xLjU5NyAxLjE2bC01LjE2NS43NTVhLjUzLjUzIDAgMCAwLS4yOTQuOTA2bDMuNzM2IDMuNjM3YTIuMSAyLjEgMCAwIDEgLjYxMSAxLjg3OWwtLjg4IDUuMTM5YS41My41MyAwIDAgMCAuNzY5LjU2bDQuNjE3LTIuNDI4LjAyNy0uMDE0IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/star-minus
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const StarMinus = createLucideIcon(__iconData);

export default StarMinus;
